// @ts-nocheck
import moment from "moment";

export const useDateFormat = (key, format) => {
  let replaced_format = "";
  replaced_format = format.replace(/%Y/, "YYYY").replace(/%m/, "MM").replace(/%d/, "DD");

  switch (key) {
    case "today":
      return moment().format(replaced_format);
    case "yesterday":
      return moment().subtract(1, "days").format(replaced_format);
    case "tomorrow":
      return moment().add(1, "days").format(replaced_format);
    case "beginning_of_month":
      return moment().startOf("month").format(replaced_format);
    case "end_of_month":
      return moment().endOf("month").format(replaced_format);
    case "beginning_of_next_month":
      return moment().add(1, "months").startOf("month").format(replaced_format);
    case "end_of_next_month":
      return moment().add(1, "months").endOf("month").format(replaced_format);
    case "beginning_of_last_month":
      return moment().subtract(1, "months").startOf("month").format(replaced_format);
    case "end_of_last_month":
      return moment().subtract(1, "months").endOf("month").format(replaced_format);
    case "this_month":
      return moment().format(replaced_format);
    case "next_month":
      return moment().add(1, "months").format(replaced_format);
    case "last_month":
      return moment().subtract(1, "months").format(replaced_format);
  }
};
